export const isPromoInDateRange = (promo, now = new Date()) => {
  if (!promo.code || !promo.startDate) return false;

  const start = new Date(promo.startDate);
  const end = promo.endDate ? new Date(promo.endDate) : null;

  if (Number.isNaN(start.getTime())) return false;
  if (end && Number.isNaN(end.getTime())) return false;

  if (now < start) return false;
  if (end && now > end) return false;
  return true;
};

/**
 * Codes pour lesquels la banner promo est affichée.
 * Les autres codes restent appliqués (panier / prix) sans banner.
 */
export const PROMO_BANNER_CODES = ['ACC15'];

export const getPromoForBanner = (promos = []) => {
  const allowed = new Set(PROMO_BANNER_CODES.map((code) => code.toUpperCase()));
  return (
    promos.find((promo) => allowed.has(String(promo?.code ?? '').toUpperCase())) ??
    null
  );
};

export const shouldApplyPromoDiscount = (itemCount, promo) => {
  if (!promo) return false;
  const minItems = promo.minItems ?? 1;
  return itemCount >= minItems;
};

const getPromoDiscountPercent = (promo) => {
  if (promo.discountPercent) return promo.discountPercent;

  const source = promo.hintDiscount ?? promo.label ?? '';
  const match = source.match(/(\d+)\s*%/);
  return match ? `${match[1]}%` : source;
};

export const getPromoBannerLabel = (promo) => {
  const percent = getPromoDiscountPercent(promo);
  const code = promo.code ?? '';

  if (!percent || !code) return '';

  return `Lancement des accessoires: -${percent} avec le code ${code}`;
};

export const getPromoMinItemsHint = (itemCount, promo) => {
  if (!promo) return null;

  const minItems = promo.minItems ?? 1;
  if (itemCount >= minItems || itemCount <= 0) return null;

  const remaining = minItems - itemCount;
  const percent = getPromoDiscountPercent(promo);
  const articleWord = remaining === 1 ? 'article' : 'articles';

  return `Ajoutez ${remaining} ${articleWord} supplémentaire${remaining > 1 ? 's' : ''} pour profiter de ${percent} de réduction`;
};
